/* eslint-disable @typescript-eslint/no-unsafe-argument,no-cond-assign */

import { Amount } from "./amount";

/**
 * Parse numbers based on locale - see https://stackoverflow.com/a/55366435
 */
export class NumberParser {
  private _group: RegExp;
  private _decimal: RegExp;
  private _numeral: RegExp;
  private _index: (d: string) => number | undefined;
  constructor(locale: string) {
    const parts = new Intl.NumberFormat(locale).formatToParts(12345.6);
    const numerals = [
      ...new Intl.NumberFormat(locale, { useGrouping: false }).format(9876543210),
    ].reverse();
    const index = new Map(numerals.map((d, i) => [d, i]));
    const find = parts.find(d => d.type === "group");
    this._group = new RegExp(`[${find?.value ?? ""}]`, "g");
    const decimal = parts.find(d => d.type === "decimal");
    this._decimal = new RegExp(`[${decimal?.value ?? ""}]`);
    this._numeral = new RegExp(`[${numerals.join("")}]`, "g");
    this._index = d => index.get(d);
  }

  // Expects string input to already be formatted with locale
  parse(string: string) {
    const result = string
      .trim()
      .replace(this._group, "")
      .replace(this._decimal, ".")
      // @ts-expect-error Actually valid operator
      .replace(this._numeral, this._index);
    let amount: Amount | undefined;
    try {
      amount = new Amount(result);
    } catch (e) {
      console.log(`Error parsing locale amount:`, e);
    }
    return result ? amount : Amount.ZERO;
  }
}
